import React from 'react';
import 'twin.macro';
import { CommentsContextProvider } from '../context/';
import { CommentsList } from './';

export const Comments = ({ itemId, item }) => (
  <CommentsContextProvider itemId={itemId} item={item}>
    <CommentsList {...{ itemId }} />
  </CommentsContextProvider>
);
